<img [src]="currentUser?.picture" class="border rounded-circle thumbnail" role="button" data-bs-toggle="modal"
    data-bs-target="#staticBackdrop">